import React from 'react';
import SearchIconMedium from './SearchIconMedium';
import SearchIconSmall from './SearchIconSmall';
const SearchIcon = ({ size = 'medium', ...props }) => size === 'medium' ? React.createElement(SearchIconMedium, { ...props }) : React.createElement(SearchIconSmall, { ...props });
export default SearchIcon;
//# sourceMappingURL=SearchIcon.js.map